import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../../screens/Login";
import NotFound from "../../screens/NotFound";
import { Loader } from "../../screens/Loader";
import { ProtectedRoute } from "../..//components/ProtectedRoute";
import { Auth } from "../../components/Auth";
import { connect } from "react-redux";
import { logout } from "../../actions";
import Loadable from "react-loadable";

const Home = Loadable({
  loader: () => import("../../screens/Home"),
  loading: Loader
});

const AppRouter = props => {
  return (
    <Switch>
      <Route path="/" component={Auth} exact={true} />
      <Route path="/login" component={Login} exact={true} />
      <ProtectedRoute path="/home" component={Home} exact={true} />
      <Route render={props => <NotFound {...props} homePath={`/home`} />} />
    </Switch>
  );
};

const mapStateToProps = state => {
  return {
    ...state
  };
};

const AR = connect(mapStateToProps, { logout })(AppRouter);

export { AR as AppRouter };
